import { Capacitor } from "@capacitor/core";

export const isProbablyTablet = (): boolean => {
    const ua = navigator.userAgent.toLowerCase();
    return /ipad|tablet|kindle|playbook/.test(ua) || (window.innerWidth >= 768);
}

export const isProbablyPhone = (): boolean => {
    return (window.innerWidth < 768);
}

export const isDesktop = (): boolean => {
    return Capacitor.getPlatform() == 'web' && (window.innerWidth >= 1024);
}